import { apiService } from "../../services/apiService";
import { apiServiceConstants } from "../../constants";
import { utilService } from "../../services/utilService";
import {
  UserRegistrationIntialGetResponce,
  UserRegistrationIntialGetParams,
  UserRegistrationInitialGetInterface,
  PostUserDetails,
  UserRegistrationInitialPostResponse,
  UserNameParams,
  UsernameCheckPostInterface,
  UsernameCheckPostResponce,
} from "./UserRegistration.models";

const userRegistrationInitialGet = async (
  params: UserRegistrationIntialGetParams
): Promise<UserRegistrationInitialGetInterface> => {
  const respApiResult = await apiService
    .apiCall(
      "user/user-registration-info/",
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const UserRegistrationInitialGetResp =
        res as UserRegistrationIntialGetResponce;
      const UserRegistrationIntialGet = setUserRegistrationIntialGetModel(
        UserRegistrationInitialGetResp
      );
      const result: UserRegistrationInitialGetInterface = {
        isSuccess: UserRegistrationInitialGetResp.isSuccess,
        UserRegistrationIntialGet: UserRegistrationIntialGet,
        status: UserRegistrationInitialGetResp.status,
        message: UserRegistrationInitialGetResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: UserRegistrationInitialGetInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setUsernameModel = (payload: UsernameCheckPostResponce) => {
  const Username = payload.result?.[0]?.username_exist;

  return Username;
};

const handleErrorResponse = () => {};

const sampleData = {
  id: 1,
  userName: "username",
  firstName: "first name",
  lastName: "last name",
  displayName: "",
  guid: "2FE8-D932-AB86-D986",
};

const userRegistrationIntialPost = async (
  params: PostUserDetails,
  reg_code: string
): Promise<UserRegistrationInitialPostResponse> => {
  const respApiResult = await apiService
    .apiCall(
      "user/user-registration-info/?reg_code=" + reg_code,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const UserRegistrationIntialPostResp =
        res as UserRegistrationInitialPostResponse;
      const result: UserRegistrationInitialPostResponse = {
        isSuccess: UserRegistrationIntialPostResp.isSuccess,
        result: UserRegistrationIntialPostResp.result,
        status: UserRegistrationIntialPostResp.status,
        message: UserRegistrationIntialPostResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: UserRegistrationInitialPostResponse = {
        isSuccess: false,
        result: "",
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const userNameGet = async (
  params: UserNameParams
): Promise<UsernameCheckPostInterface> => {
  const respApiResult = await apiService
    .apiCall(
      "user/profile-info/",
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const UsernameGetResp = res as UsernameCheckPostResponce;
      const Username = setUsernameModel(UsernameGetResp);
      const result: UsernameCheckPostInterface = {
        isSuccess: UsernameGetResp.isSuccess,
        usernameExist: Username,
        status: UsernameGetResp.status,
        message: UsernameGetResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: UserRegistrationInitialGetInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setUserRegistrationIntialGetModel = (
  payload: UserRegistrationIntialGetResponce
) => {
  const UserRegistrationIntialGet = {
    id: payload.result?.[0]?.data[0].id,
    userName: payload.result?.[0]?.data[0].username,
    firstName: payload.result?.[0]?.data[0].first_name,
    lastName: payload.result?.[0]?.data[0].last_name,
    displayName: payload.result?.[0]?.data[0].display_name,
    guid: payload.result?.[0]?.data[0].guid,
    contactDetails: payload.result?.[0]?.data[0].contact_details,
    pager: payload.result?.[0]?.data[0].pager,
    email: payload.result?.[0]?.data[0].email,
    contact_preference: payload.result?.[0]?.data[0].contact_preference,
    linkStatus: payload.result?.[0]?.data[0].link_status,
    profile_pic: payload.result?.[0]?.data[0].profile_pic,
  };
  return UserRegistrationIntialGet;
};

export const UserRegistrationService = {
  userRegistrationIntialPost,
  userRegistrationInitialGet,
  userNameGet,
  handleErrorResponse,
  sampleData,
};
